import React, {useCallback, useEffect, useState} from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {loadStripe} from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";

const BillingObject = (props) => {

	//need this to look up the checkout to make sure it got paid before showing the key
	let stripeID = null;
	const handleAfterSubmit = async () => {
		let billed = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.UPDATE);
		billed.object.token = stripeID;
		let data = await billed.submit(null, 'POST_CHECKOUT_SESSION');
		await props.handlePaidStatus()
	};

	const stripePromise = loadStripe((APPCONFIG.settings.isDev() || APPCONFIG.settings.isBeta()) ? "pk_test_51Ln4LsH1LbE5v4o227c1kTjOh3363urJxmr1E3ctMyvmQyso0P1NbY6VHJNqL5GD300OJaWOgyjS0eB9doAVP4oH00VAwTqG8g" : "pk_live_51Ln4LsH1LbE5v4o2YnJGF8VCfbZX5O3tFG3az5AoNZ7yQz9kQ3ezXl51YGFwIMzQNGiia8VzeaMhbCvKOEPLpyyQ00bHqAohHf");

	const fetchClientSecret = useCallback(async () => {
		let billing = new API.BuildClass(Types.Stripe_Charges._name, API.RequestType.CREATE);
		billing.object.customer = props.customer;
		billing.object.customer_email = props.customer_email;
		billing.object.stripe_product = props.product;
		billing.object.quantity = props.quantity;
		if (props.avCenter) {
			billing.object.av_center = true;
		}
		let data = await billing.submit(null, API.RequestType.CREATE, true);
		stripeID = JSON.parse(data.checkout_id).id;
		return JSON.parse(data.client_secret).clientSecret;
	}, [props.avCenter, props.customer, props.customer_email, props.product, props.quantity]);

	const options = {fetchClientSecret, onComplete: handleAfterSubmit};

	return (

		<div style={{width: '100%', marginBottom: 35, marginLeft: 20, marginRight: 20}}>
			<div>
				<div id="checkout">
					<EmbeddedCheckoutProvider
						stripe={stripePromise}
						options={options}
					>
						<EmbeddedCheckout/>
					</EmbeddedCheckoutProvider>
				</div>
			</div>
		</div>
	)
}

export default Framework.Components.withRootState(BillingObject);
